/*eslint-disable no-undef */
import phina from 'phina.js'

export default ()=>{

phina.define("MyManagerScene", {
    superClass : "phina.game.ManagerScene",
    init : function(param) {
        param = (param||{}).$safe(MyManagerScene.defaults);
        this.superInit({ scenes:[
        {
            label: "TitleScene",
            className: "TitleScene",
            arguments: {scale:param.scale},
        },{
            label: "StoryScene",
            className: "StoryScene",
            arguments: {scale:param.scale},
        },{
            label: "MainScene",
            className: "MainScene",
            arguments: {scale:param.scale},
        },{
            label: "BattleScene",
            className: "BattleScene",
            arguments: {scale:param.scale},
        }],
        startLabel: param.startLabel,
        });
    },
    _static: {
        defaults: {
            startLabel: "TitleScene",
            scale:1.0,
        }
    }
});

}